<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <navbar back_path="/debenture" active_screen="debenture" />
        <div class="p-16 min-h-100vh">
            <div class="bg-white br-12">
                <div class="text-center p-8 btlr-btrr-12" style="width: 100%; background-color: #cc0000">
                    <span class="fs-24 fw-600 color-white"> ข้อมูลหุ้นกู้ {{ this.final_debenture[0] ? this.final_debenture[0].next_deben_code : '' }}</span>
                </div>
                <div class="text-center p-16">
                    <span class="fs-18 fw-600">ครบกำหนดใถ่ถอน</span>
                    <span v-if="this.final_debenture && this.final_debenture[0] && this.final_debenture[0].expire_date" class="fs-18 fw-600 red">
                        {{ toMoment(this.final_debenture[0].expire_date) }}
                    </span>
                    <br />
                    <span class="fs-18 fw-600">เพื่อการจองชื่อหุ้นกู้ชุดใหม่</span>
                </div>
                <div style="width: 100%; border-bottom: 1px solid #dddddd" />
                <div class="row p-16-16-0-16">
                    <span class="fs-13 fw-600 c-999">ชื่อผู้ถือหุ้นกู้</span>
                </div>
                <div class="row p-0-16">
                    <span class="fs-18 fw-600">{{ user.custodian_name }}</span>
                </div>
                <div class="row p-16-16-0-16">
                    <span class="fs-13 fw-600 c-999">มูลค่าหุ้นกู้</span>
                </div>
                <div class="row p-0-16">
                    <span class="fs-18 fw-600">{{ nwm(invest_amount) }} บาท</span>
                </div>

                <div class="row mt-16 p-16 w-100 text-center" style="background-color: #626262">
                    <div class="col-4">
                        <span class="fs-13 fw-600 color-white">เลขทะเบียนผู้ถือหุ้นกู้ (TSD)</span>
                    </div>
                    <div class="col-4">
                        <span class="fs-13 fw-600 color-white">จำนวนหุ้นกู้</span>
                    </div>
                    <div class="col-4">
                        <span class="fs-13 fw-600 color-white">บัญชีรับเงินต้น/ดอกเบี้ย</span>
                    </div>
                </div>
                <div class="row p-16 w-100 text-center">
                    <div class="col-4">
                        <span v-if="final_rights && final_rights[0] && final_rights[0].bh_id" class="fs-14 fw-600 black">{{ final_rights[0].bh_id }}</span>
                    </div>
                    <div class="col-4">
                        <span v-if="final_rights && final_rights[0] && final_rights[0].deben_amount" class="fs-14 fw-600 black">{{ final_rights[0].deben_amount }} หน่วย</span>
                    </div>
                    <div class="col-4">
                        <span v-if="final_rights && final_rights[0] && final_rights[0].bank_abbr && final_rights[0].account_no" class="fs-14 fw-600 black">{{ final_rights[0].bank_abbr }} {{ final_rights[0].account_no }}</span>
                    </div>
                </div>
                <div class="p-16 text-center">
                    <span class="fs-18 fw-600 red">
                        * บัญชีธนาคารที่รับเงินต้นจะต้องเป็นธนาคารเดียวกับธนาคารที่ยื่นจองชื้อเท่านั้น ท่านสามารถจองชื้อได้ระหว่าง
                        {{ this.final_debenture && this.final_debenture[0] && this.final_debenture[0].subscript_period }}
                        โดยจองชื้อผ่านสาขาธนาคาร หรือจองชื้อผ่านระบบออนไลน์ของธนาคาร
                    </span>
                </div>
                <div style="width: 100%; border-bottom: 1px solid #dddddd" />
                <div class="p-16">
                    <div class="p-16-16-0-16 text-center">
                        <span class="fs-18 fw-600">ท่านสามารถจองซื้อหุ้นกู้ชุดใหม่<br />ผ่านระบบออนไลน์ของธนาคาร</span>
                    </div>
                    <div class="p-16-16-0-16 text-center">
                        <a-button size="large" class="text-center primary-btn ant-button-label-custom fs-16" style="width: 120px" @click="$router.replace({ path: '/debenture-banklist', query: { deben_id: deben_id } })">
                            <span class="fs-18 color-white">จองซื้อหุ้นกู้</span>
                        </a-button>
                    </div>
                    <div class="p-16 text-center">
                        <span class="fs-16 fw-600 red">(ผู้มีสิทธิ์จองซื้อหุ้นกู้ชุดใหม่เป็นผู้มีรายชื่อ<br />ณ วันปิดสิทธิ์ 10 มกราคม 2565)</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
import moment from 'moment';
export default {
    /* computed: {
    loading() {
      return this.$store.state.user.loading;
    },
  }, */
    components: {
        navbar,
    },
    data: function () {
        return {
            getting_data: true,
            current_page: 0,
            slides: [],
            user: this.$store.state.user,
            deben_id: this.$route.query.deben_id,
            final_debenture: [],
            final_rights: [],
            deben_amount: 0,
            invest_amount: 0,
        };
    },
    mounted() {
        this._mounted();
    },
    methods: {
        moment,
        _mounted: function () {
            this.getFinalDebenture(() => (this.getting_data = false));
        },
        getFinalDebenture: function (callback = null) {
            var self = this;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/debenture/finaldebenture',
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            console.log('self.deben_id', self.deben_id);
                            this.final_debenture = res.final_debenture.filter(function (value) {
                                return value.deben_id == self.deben_id;
                            });
                            if (this.final_debenture.length) {
                                this.final_rights = this.final_debenture[0].final_rights;
                            }
                            this.final_rights.forEach((fr) => {
                                this.deben_amount += Number(fr.deben_amount);
                                this.invest_amount += Number(fr.invest_amount);
                            });
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        handleSlideClick(dataset) {
            console.log(dataset.index, dataset.name);
        },
        handlePageChange(page) {
            this.current_page = page;
        },
        handleNext() {
            if (this.current_page < 2) {
                this.current_page = this.current_page + 1;
                this.$refs.carousel.goToPage(this.current_page);
            }
        },
        เงื่อนไขและข้อกำหนด() {
            console.log('เงื่อนไขและข้อกำหนด');
        },
        วิธีการใช้งาน() {
            console.log('วิธีการใช้งาน');
        },
        toMoment(date_unix) {
            return this.mtby(moment.unix(date_unix), 'LL');
        },
    },
};
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
<style scoped>
.dot {
    /* background-color: #808080;
  border: 1px solid #808080; */
    border-radius: 50%;
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-left: 8px;
}
.slide {
    background-color: transparent;
    /* min-height: 75vh; */
    width: 100%;
    text-align: center;
    margin-top: 40px;
}
.image {
    width: 100%;
}
.section-icons {
    width: 100%;
    background-color: rgba(128, 128, 128, 0.5);
    padding: 20px 0;
}
.main-icon {
    width: 80px;
}
.pl-2 {
    padding-left: 2px !important;
}
/* @media (max-device-width: 413px) {
  .reward-image {
    width: 50%;
  }
}
@media (max-device-width: 374px) {
  .reward-image {
    width: 40%;
  }
} */
</style>
